import React,{ useEffect, useState } from 'react';
import { history, useLocation } from 'umi';
import {Page } from 'react-weui';
import { Toast } from 'antd-mobile';
import styles from './styles.scss';


export default (props) => {

  const data = props.location.state.data;

  useEffect(()=>{

  },[]);


  return(
    <Page  transition={true} ptr={false} infiniteLoader={false}>

      <div className={styles.header}>{data.title}</div>

      <div className={styles.content}
           dangerouslySetInnerHTML={{ __html: data.content }}></div>

    </Page>
  )
}
